export function normalizeApiError(error, fallback = 'Ocurrió un error inesperado.') {
  const payload = error?.response?.data;
  const message = payload?.message || error?.message || fallback;

  if (Array.isArray(message)) {
    return message.join(', ');
  }
  if (typeof message === 'string') {
    return message;
  }
  if (typeof payload === 'string') {
    return payload;
  }
  return fallback;
}
